import { Sun, Moon } from "lucide-react";
import { AnimatePresence, motion } from "motion/react";
import useThemeStore from "../../store/themeStore";

/**
 * A single button that toggles light/dark — shows the icon for the mode
 * that's currently active, with a quiet rotate+crossfade on switch
 * (same restrained motion language as the rest of the app, no bounce).
 */
export default function ThemeToggle({ className = "" }) {
  const resolvedTheme = useThemeStore((s) => s.resolvedTheme);
  const toggle = useThemeStore((s) => s.toggle);
  const isDark = resolvedTheme === "dark";

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      className={`relative flex h-9 w-9 items-center justify-center overflow-hidden rounded-full text-ink transition-colors hover:bg-mono/5 ${className}`}
    >
      <AnimatePresence mode="wait" initial={false}>
        <motion.span
          key={isDark ? "moon" : "sun"}
          initial={{ opacity: 0, rotate: -60, scale: 0.6 }}
          animate={{ opacity: 1, rotate: 0, scale: 1 }}
          exit={{ opacity: 0, rotate: 60, scale: 0.6 }}
          transition={{ duration: 0.25, ease: [0.4, 0, 0.2, 1] }}
          className="flex items-center justify-center"
        >
          {isDark ? <Moon size={18} strokeWidth={1.8} /> : <Sun size={19} strokeWidth={1.8} />}
        </motion.span>
      </AnimatePresence>
    </button>
  );
}
